import React, { useState, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTemplate, useUser } from 'components/hooks';
import { HeadlinePage } from 'components/common';
import { useTranslation } from 'react-i18next';
import { templatePolicies, formatProjectItems } from 'helpers';
import { TemplateAbout, TemplateNotification, TemplateTag, TemplatePolling } from './TemplateStepper';
import { useStyle, ColorlibConnector, ColorlibStepIcon } from './styles';
import { Box, Paper, Stepper, Step, StepLabel, StepButton, StepContent, Button, Grid, CircularProgress, Backdrop } from '@mui/material';
import { ROUTES } from 'consts';
import { withPermission } from 'hoc';


function createMapping(projects) {
  let result = {};
  projects.forEach((p, i) => {
    result[p.value] = p;
  });
  return result;
}

const TemplateFormDumb = ({ defaultValues, handleOnSubmit, isEdit, validPermission }) => {

  const { parameters } = useUser();
  const { getFieldData, isLoaded, fieldData, fieldDataConst, success } = useTemplate();
  const projects = formatProjectItems(parameters);
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { handleSubmit, setValue, reset } = methods;
  const [activeStep, setActiveStep] = useState(0);
  const projectsMap = createMapping(projects);

  const setDataQuery = (projectId) => {
    getFieldData({
      query: {
        projectId: projectId?projectsMap[projectId].value:'',
        baseUrl: projectId?projectsMap[projectId].base_url:'',
      },
    });
  };

  useEffect(() => {
    if (isEdit) {
      setDataQuery(defaultValues.project);
      reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useEffect(() => {
    if (!isEdit) setDataQuery(defaultValues.project);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validIsEmpty = (array, field) => {
    if (array?.length > 0) {
      if (defaultValues[field]) {
        return defaultValues[field];
      } else {
        return array[0].value;
      }
    }
    else return '';
  }

  useEffect(() => {
    if (success.fieldData) {
      setValue('credential',  validIsEmpty(fieldData.credentials,  'credential'));
      setValue('userProject', validIsEmpty(fieldData.userProjects, 'userProject'));
      setValue('playbook',    validIsEmpty(fieldData.playbooks,    'playbook'));
      setValue('inventory',   validIsEmpty(fieldData.inventories,  'inventory'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldData]);

  const steps = [
    { label: 'templateList.stepper.about.label', Component: TemplateAbout },
    { label: 'templateList.stepper.tag.label', Component: TemplateTag },
    { label: 'templateList.stepper.notification.label', Component: TemplateNotification },
    { label: 'templateList.stepper.polling.label', Component: TemplatePolling },
  ];

  const onChangeProject = (value) => {
    if (value) {
      setDataQuery(value)
    }
  }

  const handleStep = (step) => () => setActiveStep(step);

  const handleNext = () => setActiveStep((prevActiveStep) => prevActiveStep + 1);

  const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={ isLoaded.post || isLoaded.put }
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage
        title={isEdit ? "templateEdit.headline" : "templateCreate.headline"}
        goBack={ROUTES.TEMPLATE_LIST}
      />
      <Paper className={classes.paperStyle}>
        <Stepper
          orientation="vertical"
          activeStep={activeStep}
          nonLinear
          connector={<ColorlibConnector />}
          sx={{ width: '100%' }}
        >
          {steps.map((step, index) => (
            <Step key={t(step.label)}>
              <StepButton color="inherit" onClick={handleStep(index)}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>{t(step.label)}</StepLabel>
              </StepButton>
              <StepContent sx={{ marginLeft: 3 }}>
                  <step.Component
                    methods={methods}
                    policies={templatePolicies}
                    fieldData={fieldData}
                    fieldDataConst={fieldDataConst}
                    projects={projects}
                    isLoaded={isLoaded.fieldData}
                    onChangeProject = {onChangeProject}
                    isEdit={isEdit}
                  />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    pt: 2,
                    justifyContent: 'flex-start',
                  }}
                >
                  <Button color="inherit" disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }}>
                    {t('templateList.stepper.backButton')}
                  </Button>
                  <Box />
                  <Button disabled={activeStep === steps.length - 1} onClick={handleNext} sx={{ mr: 1 }}>
                    {t('templateList.stepper.nextButton')}
                  </Button>
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>

        <Grid container sx={{ mt: 4 }}>
          <Grid item md={2} lg={3} />
          <Grid item xs={12} sm={12} md={8} lg={6}>
            <Button
              variant="contained"
              sx={{ width: '100%' }}
              type='submit'
              onClick={handleSubmit(handleOnSubmit)}
              // disabled={!(activeStep === (steps.length - 1))}
            >
              {isEdit ? t('templateEdit.components.submit') : t('templateCreate.components.submit')}
            </Button>
          </Grid>
          <Grid item md={2} lg={3} />
        </Grid>

      </Paper>
    </>
  );
}


export default withPermission(TemplateFormDumb, "templates");
